// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-052b4835] .v-dialog--scrollable > .v-card > .v-card__text,[data-v-052b4835] .v-dialog--scrollable > form > .v-card > .v-card__text {\n  overflow-y: hidden;\n}\n[data-v-052b4835] .v-dialog {\n  height: 600px !important;\n}\n.popup-dialog__content[data-v-052b4835] {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
